import { connect, initializable } from "effects";
import * as functions from "./functions";
import RestaurantList from "./RestaurantList";
import { get } from "object-path";

const mapStateToProps = (state, ownProps, getState) => {
  const pathId = get(ownProps, "match.params.pathId");
  return {
    loading: getState("restaurants.loading", true),
    path: getState("restaurants.path"),
    city: getState("restaurants.city"),
    restaurants: getState("restaurants.list", []),
    pathPoints: getState("app.pathPoints"),
    pathId
  };
};

export default connect(initializable(RestaurantList), mapStateToProps, functions);
